
import React from 'react';
import { I18n, Trans } from 'react-i18next';

import $ from 'jquery';
import Waypoint from 'react-waypoint';


export class Unesolution extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      animated: false
    }

    this._handleEnter = this._handleEnter.bind(this);
  }

  componentDidMount() {
    $('.sur-left-img').addClass("fade");
  }


  _handleEnter() {
    var _ = this;
    if(!this.state.animated) {
    
    setTimeout(function() {
      $('.sur-left-img').removeClass("fade");
      $('.sur-left-img').addClass('animated slideInRight');
      $('.sur-right-img').addClass('animated slideInRight delay1s');
      setTimeout(function() {
          $('.sur-right-img').removeClass("fade") 
      }, 1000);
      jQuery('#image-fade').cycle();
       _.setState({animated: true});
    },500);
  }
      
  }


  componentDidMount() {
    // var waypoint = new Waypoint({
    //       element: document.getElementById('middle-section'),
    //       handler: function(direction) {
           
    //       }
    //     });

        // var waypoint = new Waypoint({
        //   element: document.getElementById('bottom-section'),
        //   handler: function(direction) {
        //     $('.center-phone').addClass('animated slideInUp');
        //     $('.mobile-info:nth-child(2),.mobile-info:nth-child(3)').addClass('animated slideInDown delay1s');
        //     $('.mobile-info:nth-child(4),.mobile-info:nth-child(5)').addClass('animated slideInDown delay2s');
        //     $('.mobile-info:nth-child(6),.mobile-info:nth-child(7)').addClass('animated slideInDown delay3s');
              
              
        //       setTimeout(function() {
        //            $('.mobile-info:nth-child(2),.mobile-info:nth-child(3)').removeClass("fade") 
        //        }, 1000); 
        //       setTimeout(function() {
        //            $('.mobile-info:nth-child(4),.mobile-info:nth-child(5)').removeClass("fade") 
        //        }, 2000); 
        //       setTimeout(function() {
        //            $('.mobile-info:nth-child(6),.mobile-info:nth-child(7)').removeClass("fade") 
        //        }, 3000); 
             
        //            $('#image-fade1').cycle(); 
               
             
        //   }
        // });
  }


  render() {
    
    return (
    <I18n ns="translations">
        {
          (t, { i18n }) => (
            <Waypoint onEnter={this._handleEnter} bottomOffset="75%">
            <div className="container">
            <section id="middle-section">
                <div className="row">
                  <div className="col-md-7 col-sm-7 col-xs-12 mobile-text-sec">
                    <h1>{t('unetitle')} <span className="sur-text">{t('unehide')}</span></h1>
                    <p>{t('unepara1')}<i>{t('uneitalic')}</i></p>
                    <p>{t('unepara2')}<i>{t('uneitalic2')}</i>{t('unepara3')}<i>{t('uneitalic3')}</i> {t('unepara4')}</p>
                    <p>{t('unepara5')}</p>
                    <a href="https://itunes.apple.com/fr/app/hapiwine/id1068486486?mt=8" target="_blank" className="btn btn-default btn-style">{t('unebutton')}</a>
                  </div>
                  <div className="col-md-5 col-sm-5 col-xs-12 mobile-sec">

                    <img className="sur-left-img hidden-xs fade" src="../../images/sur_mesure_01.png"/>
              
                    <div id="image-fade"  className="sur-right-img hidden-xs fade fade" >
                      <img  src="../../images/sur_mesure_02.png" />
                      <img  className="" src="../../images/ecrans_arrondis_12.png" />
                      <img  className="" src="../../images/ecrans_arrondis_08.png" />
                      <img  className="" src="../../images/ecrans_arrondis_05.png" />
                    </div>           

                      
                      <img className="double-img1 double-mobile-img" src="../../images/sur_mesure_01.png" />
                      <img className="double-img2 double-mobile-img" src="../../images/sur_mesure_02.png" />
                      <img className="double-img double-tabmobile-img" src="../../images/640_mobile_img.png" />

                  </div>
                </div>
              </section>
              </div>
              </Waypoint>
            )
          }
      </I18n>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Introduction/Unesolution/Unesolution.js